"use client";

import { useSyncExternalStore } from "react";
import { QUERY_NOW_TICK_MS, queryNowBucket } from "@shared/time/query-now";

let currentNow: number | null = null;
const listeners = new Set<() => void>();
let timer: ReturnType<typeof setInterval> | null = null;

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  if (timer === null) {
    currentNow = Date.now();
    timer = setInterval(() => {
      currentNow = Date.now();
      for (const notify of listeners) notify();
    }, QUERY_NOW_TICK_MS);
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && timer !== null) {
      clearInterval(timer);
      timer = null;
      currentNow = null;
    }
  };
}

function getSnapshot(): number | null {
  return currentNow;
}

function getServerSnapshot(): null {
  return null;
}

export function useNow(): number | null {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export function useQueryNow(): number | undefined {
  const now = useNow();
  return now === null ? undefined : queryNowBucket(now);
}
